import clsx from 'clsx';

import { stringToHslColor } from '../helpers/stringToHslColor';

interface AvatarProps {
  className?: string;
  initials: string;
}

const Avatar = ({ className, initials }: AvatarProps) => {
  const color = stringToHslColor(initials);

  return (
    <div
      className={clsx(
        'rounded-circle text-info-700 flex h-8 w-8 items-center justify-center text-xs font-semibold uppercase select-none',
        className,
      )}
      style={{ backgroundColor: color }}
    >
      {initials}
    </div>
  );
};

export default Avatar;
